import { gql } from '@apollo/client';

export const sitesGql = gql`
  query sites($page: Int, $limit: Int, $order: String, $slug: String) {
    sites(page: $page, limit: $limit, order: $order, slug: $slug) {
      list {
        safeLastReport {
          _id
          logDate
          rejectedCoins
          inhibitedCoins
          sumPerCurrency
          totalAmount
        }
        _id
        monitoring {
          _id
          status
          currentAlarms {
            alarm
            effect
            extra
            startDate
          }
          lastPing
          notRespondingDelay
        }
        address1
        city
        client {
          _id
          slug
        }
        name
        terminalId
        alias
      }
      paging {
        current
        count
        limit
      }
    }
  }
`;
